import styled, {css} from 'styled-components'

export const StyledRejectedReason = styled.span(
    ({theme: {palette}}) => css`
        color: ${palette.neutral['600']};
        font-weight: 400;
    `
)
